import React, { ComponentType, FC } from "react";

import { ITypeaheadProps } from "../components";
import { IUseLoadOptionsParams, useLoadOptions } from "./useLoadOptions";

export interface ITypeaheadFactoryImplementationProps<O> extends Pick<ITypeaheadProps<O>, "loadOptions"> {}

export type ITypeaheadFactoryProps<P, O = any, S = any> = Omit<
  Pick<IUseLoadOptionsParams<O, S>, "filterAfterFetch" | "searchParams"> & P,
  keyof ITypeaheadFactoryImplementationProps<O>
>;

export const typeaheadFactory = <P extends ITypeaheadFactoryImplementationProps<O>, O = any, S = any>(
  fetchData: IUseLoadOptionsParams<O, S>["fetchData"],
  Component: ComponentType<P>,
): ComponentType<ITypeaheadFactoryProps<P, O, S>> => {
  const Typeahead: FC<ITypeaheadFactoryProps<P, O, S>> = props => {
    const { filterAfterFetch, searchParams, ...rest } = props;
    const { loadOptions } = useLoadOptions({ fetchData, filterAfterFetch, searchParams });

    return <Component {...(rest as P)} loadOptions={loadOptions} />;
  };

  return Typeahead;
};
